// ----------------- [ A4D Settings :: STATE ] ----------------- //

import {PARA__SHIPPING_INCL, PARA__TEST_MODE, PARA__VAT_INCL} from "./types";

export const state = () => ({

    // app states
    test_mode : false,

    // checkout
    checkout : {
        order : {
            is_active : false,
            is_validated : false,
            ref_component : undefined
        }
    },


    // mappings for settings / properties
    settings_map : {
        [PARA__SHIPPING_INCL]   : 'price.total_incl_shipping',
        [PARA__TEST_MODE]       : 'test_mode',
        [PARA__VAT_INCL]        : 'vat.included'
    },


    // pricing
    price: {
        total_incl_shipping : true, // calculate delivery costs for each configuration all-in-price
    },
    vat : {
        included : false,
        rate : 21,
    },

    // shipping / delivery
    delivery: {
        zone:   'NL',
        franco: 500,
        costs: {
            default: {
                0: 9.50,
                500: 0
            },
            BE: {
                0: 12.50,
                500: 0
            },
            NL: {
                0: 9.50,
                500: 0
            },
        },
    },

});
